import { companyOrderStatusSchema } from './company-order-status.schema';
import { mobileProductSchema } from './mobile-product.schema';
import { webProductSchema } from './web-product.schema';
import { coercedDate } from '../../../utils/coerced-date';
import { z } from 'zod/v4';

export const companyOrderSchema = z.object({
  targetAccountName: z.string().min(1),
  targetAccountId: z.number().nullable(),
  mobileProductOrders: z.array(mobileProductSchema).optional(),
  webProductOrders: z.array(webProductSchema).optional(),
  orderStatus: companyOrderStatusSchema,
  createdOn: coercedDate,
  modifiedOn: coercedDate,
});

export type CompanyOrder = z.infer<typeof companyOrderSchema>;
